import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const Subject_Drive_MapMasterReadSlice = createSlice({
  name: "Subject_Drive_MapMasterReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    Subject_Drive_MapMasterRead: (state) => {
      state.isLoading = true;
    },
    successSubject_Drive_MapMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureSubject_Drive_MapMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearSubject_Drive_MapMasterRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  Subject_Drive_MapMasterRead,
  failureSubject_Drive_MapMasterRead,
  successSubject_Drive_MapMasterRead,
  clearSubject_Drive_MapMasterRead,
} = Subject_Drive_MapMasterReadSlice.actions;

export default Subject_Drive_MapMasterReadSlice.reducer;
